import {
  Target,
  ComponentType,
  FontWeight,
  Direction,
  Size,
  VisualStyle,
} from 'data-types-config';
import type { DestinationItemArchetypeProps } from './DestinationItemArchetype.types';

export const destinationItemArchetypeDefaults: Partial<DestinationItemArchetypeProps> = {
  ariaLabel: '',
  componentType: ComponentType.Internal,
  isDisabled: false,
  text: '',
  target: Target.Self,
  fontWeight: FontWeight.Normal,
  direction: Direction.None,
  size: Size.Medium,
  isBlock: false,
  visualStyle: VisualStyle.Default,
  isVisible: true,
};
